import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';

export default function isSearchBoxEmpty(scenarioId: SearchScenarioId) {
    const store = getScenarioStore(scenarioId);

    return (
        store.searchText.trim().length === 0 &&
        store.suggestionPillIds.length === 0 &&
        store.suggestionSegments.size === 0
    );
}
